import React from 'react';
import { Link } from 'react-router-dom';
import PublicLayout, { PageHero } from '../../components/PublicLayout';
import { Button } from '../../components/ui/button';
import { Home, Car, Wallet, RefreshCw, ArrowRight, Check } from 'lucide-react';
import { useLanguage } from '../../lib/LanguageContext';

const credits = [
  { id: 'immobilier', icon: Home, name: 'Crédit immobilier', taux: 'à partir de 3,15% TAEG', desc: 'Achetez votre résidence principale, secondaire ou investissez locatif. Accompagnement personnalisé du dépôt à la signature.', bullets: ['Durée 7 à 25 ans', 'Frais de dossier offerts*', 'Modulation des mensualités', 'Prêt à taux zéro éligible'] },
  { id: 'auto', icon: Car, name: 'Crédit auto', taux: 'à partir de 4,50% TAEG', desc: 'Financez votre véhicule neuf ou d’occasion en quelques clics. Réponse de principe immédiate.', bullets: ['Durée jusqu’à 84 mois', 'Pas de frais de remb. anticipé', 'Assurance facultative', 'Jusqu’à 75 000 €'] },
  { id: 'conso', icon: Wallet, name: 'Crédit conso', taux: 'à partir de 4,90% TAEG', desc: 'Travaux, voyage, mariage : un prêt personnel adapté à vos projets, sans justificatif d’utilisation.', bullets: ['1 000 à 50 000 €', 'Déblocage rapide', 'Mensualités fixes', 'Souscription 100% en ligne'] },
  { id: 'rachat', icon: RefreshCw, name: 'Rachat de crédit', taux: 'Taux négocié sur mesure', desc: 'Regroupez vos prêts en une seule mensualité et allégez vos charges du quotidien.', bullets: ['1 mensualité unique', 'Jusqu’à -60% de charges', 'Simulation gratuite', 'Conseiller dédié'] },
];

export default function Credits() {
  const { t } = useLanguage();
  return (
    <PublicLayout>
      <PageHero eyebrow={t('public.creditsEyebrow')} title={t('public.creditsTitle')} subtitle={t('public.creditsSubtitle')}>
        <Link to="/inscription"><Button size="lg" className="bg-white text-blue-900 hover:bg-slate-100">{t('public.simulate')} <ArrowRight className="ml-2 w-4 h-4"/></Button></Link>
      </PageHero>
      <section className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-6">
        {credits.map((c) => (
          <div key={c.id} id={c.id} className="p-6 md:p-8 rounded-2xl border border-slate-200 bg-white hover:shadow-lg transition">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-blue-50 text-blue-700 flex items-center justify-center"><c.icon className="w-6 h-6"/></div>
              <div>
                <div className="text-xs text-blue-700 font-semibold uppercase">{c.taux}</div>
                <h2 className="font-bold text-xl text-slate-900">{c.name}</h2>
              </div>
            </div>
            <p className="text-slate-600 mt-3">{c.desc}</p>
            <ul className="mt-4 space-y-2 text-sm">
              {c.bullets.map((b, i) => <li key={i} className="flex items-start gap-2"><Check className="w-4 h-4 text-emerald-600 mt-0.5"/> {b}</li>)}
            </ul>
          </div>
        ))}
      </section>
      <div className="max-w-7xl mx-auto px-6 pb-16">
        <p className="text-xs text-slate-500">* Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous engager. Taux et offres soumis à conditions et à acceptation du dossier.</p>
      </div>
    </PublicLayout>
  );
}
